import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'
import fbSetttings from './settings'

const firebaseApp = firebase.initializeApp(fbSetttings)

export const auth = firebaseApp.auth()
export const db = firebaseApp.firestore()
export const storage = firebaseApp.storage()
export const googleProvider = new firebase.auth.GoogleAuthProvider()
